import React from "react";
import "./about.css";

import { FaAward } from "react-icons/fa";
import { AiFillProject } from "react-icons/ai";
import { VscFolderLibrary } from "react-icons/vsc";
const About = () => {
  return (
    <section id="about">
      <h5>Get to Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
           
            <img src="https://media.giphy.com/media/f3iwJFOVOwuy7K6FFw/giphy.gif" alt="about"></img>
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>1000+ hrs Coding </small>
            </article>
            <article className="about__card">
              <AiFillProject className="about__icon" />
              <h5>Projects</h5>
              <small>5+ Completed</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Clients </h5>
              <small>0 Clients</small>
            </article>
          </div>
          <p>
            Hello, My name is Mohammad Osama & 
            I'm excited to embark on my journey in the world of web development. During my academic years, I developed a solid foundation in both front-end and back-end technologies, and now I'm eager to apply my skills to real-world projects. I have a strong desire to learn, grow, and contribute to innovative web solutions.
          </p>
          <a href="#contact" className=" btn btn-primary" id="btn">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
            Contact Me
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
